/*
 * Simple 4-Pack PDP extras: Quick add (p4-pdp-designs) and the reviews histogram + page size (p4-pdp-reviews).
 * Quick add -> P4.addItems(...) then P4.packAdded(...) for 4-packs. Never opens the cart drawer itself.
 * Contract: docs/simple-4-pack/00-contract.md
 */
(function () {
  'use strict';

  if (window.P4PdpExtras) return;
  window.P4PdpExtras = { version: 1 };

  function $(root, sel) {
    return root.querySelector(sel);
  }
  function $$(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function money(cents, format) {
    if (window.P4 && typeof window.P4.formatMoney === 'function') return window.P4.formatMoney(cents, format);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function hasP4() {
    return !!(window.P4 && typeof window.P4.addItems === 'function' && typeof window.P4.packAdded === 'function');
  }

  /* ---------------------------------------------------------------- Quick add */

  function initQuickAdd(root) {
    $$(root, '[data-p4-quick-add]').forEach(function (btn) {
      if (btn.__p4Bound) return;
      btn.__p4Bound = true;
      var card = btn.closest('li') || btn.parentNode;
      var error = card && $(card, '[data-p4-quick-error]');
      var form = btn.form || btn.closest('form');
      var trigger = function (e) {
        // Without the shared helpers the wrapping form posts natively to /cart/add.
        if (!hasP4()) return;
        if (e) e.preventDefault();
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        var variantId = Number(btn.getAttribute('data-variant-id'));
        var productId = Number(btn.getAttribute('data-product-id'));
        var labelHtml = btn.innerHTML;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = '…';
        if (error) error.hidden = true;
        var includes = btn.getAttribute('data-includes');
        var item = { id: variantId, quantity: 1 };
        if (includes) item.properties = { Includes: includes }; // like the classic product forms
        window.P4.addItems([item])
          .then(function (response) {
            if (!window.P4.isPackProduct(productId)) {
              window.P4.refreshCartDrawer({ open: true });
              return;
            }
            window.P4.packAdded({
              productId: productId,
              variantId: variantId,
              quantity: 1,
              sellingPlanId: null,
              source: 'quick-add',
              response: response
            });
          })
          .catch(function (err) {
            if (error) {
              error.textContent = (err && err.message) || 'Sorry, something went wrong. Please try again.';
              error.hidden = false;
            }
          })
          .then(function () {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.innerHTML = labelHtml;
          });
      };
      if (form) form.addEventListener('submit', trigger);
      else btn.addEventListener('click', trigger);
    });
  }

  /* ------------------------------------------------- Card image -> hero design */

  // On the PDP, a card for a design the hero can show switches the hero to it (no reload).
  // The link's href stays the fallback (no JS, other pages, modifier clicks).
  function initDesignLinks(root) {
    $$(root, '[data-p4-design-link]').forEach(function (link) {
      if (link.__p4Bound) return;
      link.__p4Bound = true;
      link.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var pdpEl = document.querySelector('[data-p4-pdp]');
        var pdp = pdpEl && pdpEl.__p4Pdp;
        if (!pdp || !pdp.designs || typeof pdp.selectDesign !== 'function') return;
        var variantId = Number(link.getAttribute('data-variant-id'));
        var productId = Number(link.getAttribute('data-product-id'));
        var index = -1;
        for (var i = 0; i < pdp.designs.length; i++) {
          var d = pdp.designs[i];
          if (Number(d.variantId) === variantId || (pdp.mode === 'products' && productId && Number(d.productId) === productId)) {
            index = i;
            break;
          }
        }
        if (index < 0) return;
        e.preventDefault();
        pdp.selectDesign(index);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // The announcement + header stick to the top: land the PDP just below them.
        var chrome = document.querySelector('.p4-chrome-top');
        var offset = chrome ? Math.max(0, chrome.getBoundingClientRect().bottom) : 0;
        var top = pdpEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        var focusEl = pdp.picker && pdp.picker.toggle;
        if (focusEl && typeof focusEl.focus === 'function') focusEl.focus({ preventScroll: true });
      });
    });
  }

  /* Quick-add order follows the design picked above (client, Oct 16): the cards rotate so the design on
     view comes last and the others follow it in their usual order, e.g. Pretty Patterns on view ->
     Minimal & Neutral, Solids, Florals, Pretty Patterns. The grid's per-position styles (nth-child) stay
     with the position. p4-pdp.js fires p4:design-change on every pick. */
  function initDesignOrder(root) {
    $$(root, '.p4-designs__grid').forEach(function (grid) {
      if (grid.__p4Order) return;
      var cards = $$(grid, ':scope > .p4-designs__card');
      if (cards.length < 2) return;
      grid.__p4Order = function (variantId, productId) {
        var at = -1;
        cards.forEach(function (card, i) {
          var link = $(card, '[data-p4-design-link]');
          if (!link || at > -1) return;
          if (variantId && Number(link.getAttribute('data-variant-id')) === variantId) at = i;
        });
        if (at < 0 && productId) {
          var hits = cards.filter(function (card) {
            var link = $(card, '[data-p4-design-link]');
            return link && Number(link.getAttribute('data-product-id')) === productId;
          });
          // Products mode: one card per product. Variant mode: every card shares the product id.
          if (hits.length === 1) at = cards.indexOf(hits[0]);
        }
        if (at < 0) return;
        var order = cards.slice(at + 1).concat(cards.slice(0, at + 1));
        var same = order.every(function (card, i) {
          return grid.children[i] === card;
        });
        if (!same) order.forEach(function (card) { grid.appendChild(card); });
      };
      var pdpEl = document.querySelector('[data-p4-pdp]');
      var d = pdpEl && pdpEl.__p4Pdp && pdpEl.__p4Pdp.design && pdpEl.__p4Pdp.design();
      if (d) grid.__p4Order(Number(d.variantId), Number(d.productId));
    });
  }

  document.addEventListener('p4:design-change', function (e) {
    var d = e.detail || {};
    $$(document, '.p4-designs__grid').forEach(function (grid) {
      if (grid.__p4Order) grid.__p4Order(Number(d.variantId), Number(d.productId));
    });
  });

  /* ---------------------------------------------------------------- Reviews */

  function noop() {}

  /* ------------------------------------------------- Deferred below-the-fold loading */

  // Runs cb once the shopper starts using the page (scroll, touch, pointer, key) — never during the
  // initial load, so nothing below the fold competes with the hero (and lab tests that don't scroll
  // don't fetch it). Immediately when the page is already scrolled (restored position, #anchor).
  var engagedCbs = null;
  function whenEngaged(cb) {
    if (window.pageYOffset > 0 || engagedCbs === false) return cb();
    if (!engagedCbs) {
      engagedCbs = [];
      var evs = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
      var fire = function (e) {
        // Element scrolls (e.g. the gallery track positioning itself) reach capture listeners too.
        if (e && e.type === 'scroll' && e.target !== document && e.target !== window) return;
        evs.forEach(function (t) {
          window.removeEventListener(t, fire, true);
        });
        var list = engagedCbs;
        engagedCbs = false;
        list.forEach(function (f) {
          f();
        });
      };
      evs.forEach(function (t) {
        window.addEventListener(t, fire, { capture: true, passive: true });
      });
    }
    engagedCbs.push(cb);
  }

  // cb once el is within `margin` of the viewport, after the shopper engaged.
  function whenNear(el, margin, cb) {
    whenEngaged(function () {
      if (!('IntersectionObserver' in window)) return cb();
      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            io.disconnect();
            cb();
          }
        },
        { rootMargin: margin + 'px 0px' }
      );
      io.observe(el);
    });
  }

  // <noscript data-p4-defer><img …></noscript> -> the real image.
  function hydrate(root) {
    $$(root, 'noscript[data-p4-defer]').forEach(function (ns) {
      var tpl = document.createElement('template');
      tpl.innerHTML = ns.textContent || '';
      ns.parentNode.replaceChild(tpl.content, ns);
    });
  }

  function initDeferredImages(root) {
    $$(root, '[data-p4-designs]').forEach(function (sec) {
      if (sec.__p4Deferred) return;
      sec.__p4Deferred = true;
      // Cutout images + the title font ("P4 Awesome Serif", lazy @font-face: only downloaded once text uses it).
      whenNear(sec, 800, function () {
        sec.classList.add('p4-designs--font');
        hydrate(sec);
      });
    });
  }

  // Fills the theme histogram (5 → 1 stars) from the counts in Judge.me's own (hidden) histogram.
  function fillHistogram(root, widget) {
    var hist = $(root, '[data-p4-histogram]');
    // Already rendered server-side from the widget metafield.
    if (!hist || hist.hasAttribute('data-p4-ready')) return true;
    var rows = $$(widget, '.jdgm-histogram__row[data-rating]').filter(function (r) {
      return /^[1-5]$/.test(r.getAttribute('data-rating'));
    });
    if (!rows.length) return false;
    var freq = {};
    var total = 0;
    rows.forEach(function (r) {
      var n = parseInt(r.getAttribute('data-frequency'), 10) || 0;
      freq[r.getAttribute('data-rating')] = n;
      total += n;
    });
    $$(hist, '[data-p4-hrow]').forEach(function (li) {
      var k = li.getAttribute('data-p4-hrow');
      var n = freq[k] || 0;
      var pct = total ? (n / total) * 100 : 0;
      var fill = $(li, '.p4-reviews__hfill');
      var bar = $(li, '.p4-reviews__hbar');
      if (fill) fill.style.width = pct.toFixed(2) + '%';
      if (bar) bar.setAttribute('aria-label', k + ' stars: ' + n + ' reviews (' + Math.round(pct) + '%)');
    });
    hist.hidden = false;
    return true;
  }

  /* Judge.me core (settings + loader) sits inert in <template data-p4-jdgm-core>. Inject it once the
     reviews come within ~600px of the viewport, so Judge.me's JS / CSS never compete with the first paint.
     Scripts cloned from a template do not run, so they are re-created. */
  function injectJudgeme(root) {
    var tpl = $(root, 'template[data-p4-jdgm-core]');
    if (!tpl || tpl.__p4Done) return;
    tpl.__p4Done = true;
    if (window.jdgmSettings) return; // core already on the page (another layout)
    Array.prototype.slice.call(tpl.content.childNodes).forEach(function (node) {
      if (node.nodeName === 'SCRIPT') {
        var sc = document.createElement('script');
        Array.prototype.forEach.call(node.attributes, function (a) {
          sc.setAttribute(a.name, a.value);
        });
        sc.text = node.textContent;
        document.body.appendChild(sc);
      } else if (node.nodeName !== 'NOSCRIPT') {
        document.body.appendChild(document.importNode(node, true));
      }
    });
  }

  function lazyJudgeme(root) {
    if (!$(root, 'template[data-p4-jdgm-core]')) return;
    whenNear(root, 600, function () {
      injectJudgeme(root);
    });
  }

  /* Judge.me's page fetch has no error handler: before the request it hides .jdgm-rev-widg__body (reviews +
     pagination) and shows its spinner, so a failed fetch (its CDN answers 429 "Too Many Requests", retry-after
     5 s, without CORS headers) leaves the widget empty and every later click dead. On such an error: show the
     body again and retry the page that was clicked, after 6 s then 12 s. */
  function guardPaginate(root) {
    var lastPage = null;
    var tries = 0;
    root.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest && e.target.closest('.jdgm-paginate__page');
        if (a && e.isTrusted) {
          lastPage = a.getAttribute('data-page');
          tries = 0;
        }
      },
      true
    );
    var bound = false;
    var bind = function () {
      var jq = window.jdgm && window.jdgm.$;
      if (bound || !jq) return bound;
      bound = true;
      jq(document).on('ajaxError', function (ev, xhr, settings) {
        if (!settings || !/reviews_for_widget/.test(settings.url || '')) return;
        var widget = jq(root).find('.jdgm-rev-widg');
        if (!widget.length) return;
        widget.find('.jdgm-rev-widg__paginate-spinner-wrapper').hide();
        widget.find('.jdgm-rev-widg__body').show();
        if (!lastPage || tries >= 2) return;
        tries++;
        var page = lastPage;
        window.setTimeout(function () {
          var link = widget.find('.jdgm-paginate__page[data-page="' + page + '"]:not(.jdgm-curt)').first();
          if (link.length) link.trigger('click');
        }, 6000 * tries);
      });
      return true;
    };
    if (bind()) return;
    var n = 0;
    var timer = window.setInterval(function () {
      if (bind() || ++n > 120) window.clearInterval(timer);
    }, 500);
  }

  function initReviews(root) {
    if (root.__p4Bound) return;
    root.__p4Bound = true;
    lazyJudgeme(root);
    whenEngaged(function () {
      guardPaginate(root);
    });
    var widget = $(root, '.p4-reviews__widget');
    if (!widget) return;
    // Reviews per page is Judge.me's own setting (admin → Judge.me → Reviews widget). Re-paginating
    // from here made Judge.me scroll the page to the widget on load, so it is not done in JS.
    var histDone = false;
    function step() {
      if (!histDone) histDone = fillHistogram(root, widget);
      return histDone;
    }
    if (step() || !window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (step()) obs.disconnect();
    });
    obs.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    window.setTimeout(function () {
      obs.disconnect();
    }, 20000);
  }

  /* ---------------------------------------------------------------- Boot */

  function boot(scope) {
    scope = scope || document;
    initQuickAdd(scope);
    initDesignLinks(scope);
    initDesignOrder(scope);
    initDeferredImages(scope);
    $$(scope, '[data-p4-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
